//
//
//
//
//


export default {
  props: {
    value: Boolean,
    hideCross: {
      type: Boolean,
      default: false
    }
  }
}
